import React, { useEffect, useState } from 'react';
import * as api from '../api/api';
import axios from 'axios';
import AdminLayout from './AdminLayout';

const ManageResume = () => {
    const [resumeUrl, setResumeUrl] = useState('');
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchResume = async () => {
            try {
                const { data } = await api.fetchConfig('resume');
                setResumeUrl(data.value);
            } catch (error) {
                console.log(error);
            }
        };
        fetchResume();
    }, []);

    const uploadFileHandler = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('image', file);
        setUploading(true);

        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };

            const { data } = await axios.post(`${api.BASE_URL}/api/upload`, formData, config);
            setResumeUrl(`${api.BASE_URL}${data}`);
            setUploading(false);
            setMessage('Upload successful! Click save to apply.');
        } catch (error) {
            console.error(error);
            setUploading(false);
            setMessage('Upload failed. Ensure file is an image/pdf depending on backend config.');
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            await api.updateConfig('resume', resumeUrl);
            setMessage('Resume updated successfully!');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            setMessage('Failed to update resume.');
        }
    };

    return (
        <AdminLayout title="Manage Resume">
            <div className="max-w-2xl mx-auto py-8">
                <div className="bg-gray-800 rounded-lg shadow-xl border border-gray-700 p-8">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-500/10 mb-4 border border-yellow-500/20 shadow-[0_0_15px_rgba(234,179,8,0.1)]">
                            <i className="fas fa-file-pdf text-3xl text-yellow-500"></i>
                        </div>
                        <h2 className="text-2xl font-bold text-white tracking-tight">Resume Configuration</h2>
                        <p className="text-gray-400 mt-2 text-sm">Update the resume link displayed on your portfolio</p>
                    </div>

                    {message && (
                        <div className={`mb-6 p-4 rounded-md flex items-center text-sm font-medium ${message.toLowerCase().includes('failed')
                            ? 'bg-red-900/20 text-red-400 border border-red-500/20'
                            : 'bg-green-900/20 text-green-400 border border-green-500/20'
                            }`}>
                            <i className={`fas ${message.toLowerCase().includes('failed') ? 'fa-exclamation-circle' : 'fa-check-circle'} mr-3 text-lg`}></i>
                            {message}
                        </div>
                    )}

                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-400 mb-2">Current Resume URL</label>
                            <div className="relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <i className="fas fa-link text-gray-500"></i>
                                </div>
                                <input
                                    type="text"
                                    className="w-full bg-gray-900 border border-gray-600 rounded-md pl-10 pr-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-all shadow-sm placeholder-gray-600 sm:text-sm"
                                    value={resumeUrl}
                                    onChange={(e) => setResumeUrl(e.target.value)}
                                    placeholder="https://example.com/my-resume.pdf"
                                />
                            </div>
                        </div>

                        <div className="relative my-8">
                            <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                <div className="w-full border-t border-gray-700"></div>
                            </div>
                            <div className="relative flex justify-center">
                                <span className="px-3 bg-gray-800 text-xs font-medium text-gray-500 uppercase tracking-wider">OR UPLOAD FILE</span>
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-400 mb-2">Upload New File (PDF)</label>
                            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md hover:border-yellow-500 hover:bg-gray-700/30 transition-all cursor-pointer group relative">
                                <div className="space-y-1 text-center">
                                    <i className="fas fa-cloud-upload-alt text-4xl text-gray-400 group-hover:text-yellow-500 transition-colors mb-3"></i>
                                    <div className="flex text-sm text-gray-400">
                                        <label htmlFor="file-upload" className="relative cursor-pointer bg-transparent rounded-md font-medium text-yellow-500 hover:text-yellow-400 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-yellow-500">
                                            <span>Upload a file</span>
                                            <input id="file-upload" name="file-upload" type="file" className="sr-only" onChange={uploadFileHandler} />
                                        </label>
                                        <p className="pl-1">or drag and drop</p>
                                    </div>
                                    <p className="text-xs text-gray-500">PDF, JPG, PNG up to 5MB</p>
                                </div>
                            </div>
                            {uploading && (
                                <div className="mt-4">
                                    <div className="w-full bg-gray-700 rounded-full h-1.5 overflow-hidden">
                                        <div className="bg-yellow-500 h-1.5 rounded-full animate-progress w-full origin-left"></div>
                                    </div>
                                    <p className="text-xs text-yellow-500 mt-2 text-center font-mono">Uploading...</p>
                                </div>
                            )}
                        </div>

                        <button
                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 mt-6 shadow-lg hover:shadow-indigo-500/30"
                            onClick={submitHandler}
                        >
                            <i className="fas fa-save mr-2"></i> Save Resume Link
                        </button>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default ManageResume;
